import { createUseStyles } from "react-jss";
import headerLg from "../../../images/pages/index/header/index-header-img.webp";
import headerMd from "../../../images/pages/index/header/index-header-img-md.webp";
import headerSm from "../../../images/pages/index/header/index-header-img-sm.webp";
import headerLgRu from "../../../images/pages/index/header/index-header-img-ru.webp";
import headerMdRu from "../../../images/pages/index/header/index-header-img-md-ru.webp";
import headerSmRu from "../../../images/pages/index/header/index-header-img-sm-ru.webp";
import subOne from "../../../images/pages/ru-index/sub-one-xl.svg";
import subTwo from "../../../images/pages/ru-index/sub-two-xl.svg";
import {getCurrentLang} from "../../../locales/locales-utils";

const isRuLang = getCurrentLang() === "ru";

export const useAppStyles = createUseStyles({
  header: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: 800,
    height: "auto",
    background: `url(${headerLg}) no-repeat`,
    backgroundSize: "cover",
    overflowX: "hidden",
    "&$headerRu": {
      background: `url(${headerLgRu}) no-repeat`,
      backgroundSize: "cover"
    },
    "& .headerInside": {
      "& > div > div:first-child": {
        marginTop: 50,
        "@media (max-width: 1200px)": {
          marginTop: 0
        }
      }
    },
    "@media (max-width: 1200px)": {
      background: `url(${headerMd}) no-repeat`,
      minHeight: "unset",
      backgroundSize: "cover",
      "&$headerRu": {
        background: `url(${headerMdRu}) no-repeat`,
        backgroundSize: "cover"
      }
    },
    "@media (max-width: 600px)": {
      height: "auto",
      background: `url(${headerSm}) no-repeat`,
      backgroundSize: "cover",
      "&$headerRu": {
        background: `url(${headerSmRu}) no-repeat`,
        backgroundSize: "cover"
      }
    }
  },
  headerRu: {},
  brands: {
    paddingTop: 64,
    paddingBottom: 60,
    "@media (max-width: 1200px)": {
      paddingTop: 40,
      paddingBottom: 24
    }
  },
  cloudPlatformEvents: {
    paddingTop: 80,
    paddingBottom: 188,
    "& .h1": {
      marginBottom: 16
    },
    "& .cloud-platform-events-card": {
      "@media (max-width: 1200px)": {
        marginTop: 48,
        "& .cardTexHelper": {
          marginTop: 48,
          paddingRight: 0,
          "& a.order-button": {
            minWidth: 340
          }
        },
        "& .cardImgHelper": {
          width: "100%",
          height: 389,
          "& iframe": {
            height: "inherit"
          }
        }
      },
      "@media (max-width: 600px)": {
        marginTop: 40,
        "& .cardTexHelper": {
          marginTop: 40,
          "& .h2": {
            fontSize: 16
          },
          "& a.order-button": {
            minWidth: "100%"
          }
        },
        "& .cardImgHelper": {
          width: "100%",
          height: 200,
          "& iframe": {
            height: "inherit"
          }
        }
      }
    },
    "@media (max-width: 1200px)": {
      paddingTop: 80,
      paddingBottom: 121
    },
    "@media (max-width: 600px)": {
      paddingTop: 40,
      paddingBottom: 80
    }
  },
  announcementsCarousel: {
    paddingTop: 152,
    background: "#6049EB",
    overflowX: "hidden",
    "@media (max-width: 1200px)": {
      paddingTop: 120,
      paddingBottom: 72
    },
    "@media (max-width: 600px)": {
      paddingTop: 80,
      paddingBottom: 32
    },
  },
  canDoForYou: {
    background: "url(\"data:image/svg+xml,%3Csvg width='1709' height='366' viewBox='0 0 1709 366' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M9.1865 145.009C11.3683 145.117 13.0652 146.574 14.6962 147.986C16.4747 149.526 18.3933 151.061 18.808 153.34C19.2946 156.015 18.9067 158.952 17.0622 160.993C15.1286 163.133 12.1136 164.125 9.1865 163.987C6.38337 163.855 3.83868 162.378 2.04021 160.284C0.392278 158.366 -0.162573 155.831 0.0397945 153.34C0.225741 151.051 1.36202 148.982 3.08592 147.412C4.75018 145.896 6.90833 144.896 9.1865 145.009Z' fill='%2365C15D'/%3E%3Cg filter='url(%23filter0_f_10729_301090)'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M1563.75 9.01774C1566.76 9.14785 1569.54 10.4728 1571.46 12.7664C1573.41 15.1093 1574.41 18.1141 1573.84 21.0962C1573.24 24.2197 1571.4 27.1646 1568.44 28.4363C1565.59 29.6636 1562.36 28.7211 1559.66 27.1979C1557.21 25.8203 1555.71 23.4736 1554.92 20.8118C1554.04 17.8668 1553.29 14.5318 1555.14 12.0617C1557.05 9.51856 1560.54 8.87936 1563.75 9.01774Z' fill='%237770FF'/%3E%3C/g%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M1697.63 72.0598C1701.26 71.9091 1705.41 71.8221 1707.68 74.6878C1709.94 77.5516 1708.78 81.5542 1707.96 85.1195C1707.14 88.6632 1706.27 92.4472 1703.16 94.2994C1699.76 96.3184 1695.32 96.6635 1691.92 94.662C1688.73 92.7899 1688.11 88.7303 1687.47 85.0776C1686.89 81.741 1686.48 78.1452 1688.56 75.4792C1690.66 72.7928 1694.23 72.2002 1697.63 72.0598Z' fill='%23FFC83C'/%3E%3Cg filter='url(%23filter1_f_10729_301090)'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M1543.86 314.018C1548.33 314.237 1551.82 317.196 1555.17 320.064C1558.82 323.191 1562.75 326.306 1563.61 330.934C1564.6 336.365 1563.81 342.329 1560.02 346.473C1556.05 350.818 1549.86 352.833 1543.86 352.553C1538.1 352.284 1532.88 349.285 1529.19 345.034C1525.81 341.139 1524.67 335.992 1525.08 330.934C1525.46 326.287 1527.8 322.086 1531.33 318.898C1534.75 315.82 1539.18 313.789 1543.86 314.018Z' fill='%2365C15D'/%3E%3C/g%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M46.3689 324C49.8805 324.005 53.4876 324.969 55.5977 327.493C57.6496 329.947 57.5611 333.265 56.5725 336.204C55.6734 338.877 53.5204 341.03 50.6705 342.141C47.9612 343.196 44.8965 342.976 42.2603 341.78C39.6884 340.613 38.0303 338.467 37.1424 336.003C36.1161 333.155 35.209 329.929 37.1023 327.466C39.1034 324.863 42.8492 323.995 46.3689 324Z' fill='%23FFA900'/%3E%3Cdefs%3E%3Cfilter id='filter0_f_10729_301090' x='1545' y='0' width='38' height='38' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3E%3CfeFlood flood-opacity='0' result='BackgroundImageFix'/%3E%3CfeBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape'/%3E%3CfeGaussianBlur stdDeviation='4.5' result='effect1_foregroundBlur_10729_301090'/%3E%3C/filter%3E%3Cfilter id='filter1_f_10729_301090' x='1512' y='301' width='65' height='64.5791' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3E%3CfeFlood flood-opacity='0' result='BackgroundImageFix'/%3E%3CfeBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape'/%3E%3CfeGaussianBlur stdDeviation='6.5' result='effect1_foregroundBlur_10729_301090'/%3E%3C/filter%3E%3C/defs%3E%3C/svg%3E%0A\")",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center bottom 82px",
    backgroundColor: "#6049EB",
    paddingTop: 200,
    paddingBottom: 200,
    "@media (max-width: 1200px)": {
      background: "#6049EB",
      paddingTop: 120,
      paddingBottom: 160
    },
    "@media (max-width: 600px)": {
      paddingTop: 80,
      paddingBottom: 80
    }
  },
  bottomSection: {
    background: `url(${subOne}) no-repeat, linear-gradient(0deg, #EFEDFD 0%, #FFFFFF 100%)`,
    backgroundSize: "100%",
    backgroundPosition: "top, 0 0",
    paddingTop: 160,
    paddingBottom: 0,
    overflow: "hidden",
    "@media (max-width: 1200px)": {
      paddingTop: 120,
      paddingBottom: 0,
      backgroundSize: "230%, cover"
    },
    "@media (max-width: 600px)": {
      paddingTop: 80,
      paddingBottom: 0,
      backgroundSize: "330%, cover"
    }
  },
  comments: {
    paddingTop: 200,
    "@media (max-width: 1200px)": {
      paddingTop: 160
    },
    "@media (max-width: 600px)": {
      paddingTop: 120
    }
  },
  faq: {
    background: `url(${subTwo}) no-repeat`,
    backgroundSize: "100%",
    backgroundPosition: "bottom, 0 0",
    paddingTop: 160,
    paddingBottom: 250,
    "@media (max-width: 1200px)": {
      paddingTop: 120,
      paddingBottom: 140,
      backgroundSize: "160%, cover"
    },
    "@media (max-width: 600px)": {
      paddingTop: 100,
      paddingBottom: 120,
      backgroundSize: "330%, cover"
    }
  },
  contactsAndSocial: {
    paddingTop: 24,
    paddingBottom: 24,
    background: "#6049EB",
    "@media (max-width: 600px)": {
      paddingTop: 40,
      paddingBottom: 40
    }
  },
  links: {
    background: "#3A28A7",
    paddingTop: 56,
    paddingBottom: 64,
    "@media (max-width: 1200px)": {
      paddingTop: 40,
      paddingBottom: 80
    },
    "@media (max-width: 600px)": {
      paddingBottom: 64
    }
  },
  copyRight: {
    paddingBottom: 40,
    background: "#3A28A7"
  }
});
